import { createSelector } from "reselect";

export const liabilities = ({ liabilities }) => liabilities.items;

export const totalLiabilitiesAmount = createSelector(
  liabilities,
  (liabilities) => {
    if (liabilities.length) {
      return liabilities.reduce(
        (sum, obj) =>
          obj.liabilityStatus === "pending"
            ? sum + obj.liabilityAmount
            : sum + 0,

        0
      );
    }
  }
);
